/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '@sharefiledev/flow-web';
export const OvalIcon = createIcon("OvalIcon", (title, _color = '#000') => <svg data-replace-color={_color} width="17" height="18" viewBox="0 0 17 18" fill="none"><title>{title}</title><path d="M8.666 16.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15Z" stroke={_color} strokeWidth="1.5"/></svg>, {"replaceColor":true});